module.exports = __webpack_public_path__ + "img/monetization-feature-1.1e9e72b7.svg";